require('./es6.array.iterator');
var Iterators = require('./$.iterators');
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/web.dom.iterable.js
// module id = 730
// module chunks = 0